
import desktop_ver from "./desktop_ver/index"
import mobile_ver from "./mobile_ver/index"
import {
  Page
} from "app/multi_device"

const onLoad = () => {

  if ( Page.isForMobile() ) {
    mobile_ver.init()
  }
  else {
    desktop_ver.init()
  }

}

export default {onLoad}
